import PropTypes from 'prop-types';
import React from 'react';

import ContainerlessDataTable from '../../DataTable/components/ContainerlessDataTable';
import FilterPanel from './FilterPanel';
import { useContainerlessTableViewContext } from '../startup/ContainerlessTableViewApp';

const reduceFilters = (filters, hiddenFilterParams = []) => {
  return filters.filter((filter) => {
    return filter.value.length > 0 && !hiddenFilterParams.includes(filter.paramName);
  }).reduce((params, filter) => {
    var newParam = {};
    newParam[filter.paramName] = filter.value;

    return Object.assign(params, newParam);
  }, {});
}

const ContainerlessTableView = ({
  title,
  searchedSearchTerm,
  dataSource,
  columns,
  order,
  pageLength,
  lengthMenu,
  filters,
  updateFilter,
  debouncedUpdateFilter,
  clearFilterValues,
  tableClassNames,
  dataTableEl,
  dataTableElChanged,
  rowCallback,
  drawCallback,
}) => {
  const { hiddenFilterParams = [] } = useContainerlessTableViewContext();

  return (
    <div>
      {filters && filters.length > 0 ? (
        <div style={{ padding: "12px 24px" }}>
          <FilterPanel filters={filters}
                      clearFilterValues={clearFilterValues}
                      debouncedUpdateFilter={debouncedUpdateFilter}
                      updateFilter={updateFilter}
                      hiddenFilterParams={hiddenFilterParams} />
        </div>
      ) : null}
      <div className="row">
        <div className="col-12">
          <div key={filters.map(filter => filter.value)}>
            <ContainerlessDataTable
              title={title}
              searchedSearchTerm={searchedSearchTerm}
              dataSource={dataSource}
              columns={columns}
              reducedFilters={reduceFilters(filters, hiddenFilterParams)}
              tableClassNames={tableClassNames}
              pageLength={pageLength}
              lengthMenu={lengthMenu}
              onInitComplete={(settings, json) => {
                dataTableEl.current = settings.oInstance[0]
                dataTableElChanged(dataTableEl.current);
              }}
              rowCallback={rowCallback}
              drawCallback={drawCallback}
              order={order}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

ContainerlessTableView.propTypes = {
  title: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  typedSearchTerm: PropTypes.string,
  searchedSearchTerm: PropTypes.string,
  startSearchTermUpdate: PropTypes.func,
  dataSource: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  order: PropTypes.array,
  pageLength: PropTypes.number,
  lengthMenu: PropTypes.array,
  filters: PropTypes.array,
  updateFilter: PropTypes.func.isRequired,
  debouncedUpdateFilter: PropTypes.func.isRequired,
  clearFilterValues: PropTypes.func.isRequired,
  tableClassNames: PropTypes.string,
  csvDataSource: PropTypes.string,
  dataTableEl: PropTypes.object,
  dataTableElChanged: PropTypes.func.isRequired,
  rowCallback: PropTypes.func,
  drawCallback: PropTypes.func,
  layout: PropTypes.string
};

export default ContainerlessTableView;
